import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Zoom from 'react-reveal/Zoom';
import { Link } from 'react-router-dom';

import ClassImg from '../../static/img/home_page/classes_dance_fitness_class.webp';
import NiaTVImg from '../../static/img/home_page/at-home_dance_workout_online.webp';
import DebbieImg from '../../static/img/home_page/debbie_writing.webp';

const styles = theme => ({
  section: {
    width: '100%',
    backgroundColor: '#EEEEEE',
    position: 'relative',
    padding: theme.spacing(3),
    paddingTop: theme.spacing(12),
    paddingBottom: theme.spacing(12),
    margin: '0 auto',
  },
  content: {
    width: '100%',
    [theme.breakpoints.up(900)]: {
      width: '900px',
    },
    margin: '0 auto',
  },
  icon: {
    width: 'auto',
    height: '175px',
    textAlign: 'center',
    margin: theme.spacing(2),
    // borderStyle: 'solid',
    // border: '1px black',
    boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
    transition: 'transform .2s',
    '&:hover': {
      transform: 'scale(1.03)',
    },
  },
  threeOptionHeader: {
    textAlign: 'center',
  },
  threeOptionItemContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  threeOptionsColumn: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    maxWidth: '300px',
    margin: theme.spacing(2),
  },
  threeOptionZoom: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
  },
  link: {
    textDecoration: 'none',
    color: 'white',
  },
  sectionText: {
    marginBottom: theme.spacing(2),
    textAlign: 'center',
  },
  sectionTextNewline: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up(900)]: {
      marginBottom: '37px',
    },
  },
  threeOptionsHeader: {
    fontSize: 22,
  },
});

function ThreeOptionsSection(props) {
  const { classes } = props;
  return (
    <div className={classes.section}>
      <div className={classes.content}>
        <Grid container>
          {/* Debbie Rosas */}
          <Grid item xs={12} md={4} className={classes.threeOptionItemContainer}>
            <Zoom>
              <div className={classes.threeOptionsColumn}>
                <Typography className={classes.threeOptionsHeader} variant="h3" color="textSecondary">DEBBIE ROSAS</Typography>
                <a target="_blank" rel="noopener noreferrer" href="https://debbierosas.com">
                  <img className={classes.icon} alt="Debbie rosas sitting at a table with flowers" src={DebbieImg} loading="lazy" />
                </a>
                <Typography className={classes.sectionText} color="textSecondary">Nia Technique Founder, Director, Educator, & Artist, Debbie Rosas.  Click To Visit Debbie&apos;s New Interactive Online Destination, Awakening Body & Life</Typography>
                <Button href="https://debbierosas.com" target="_blank" className={classes.threeOptionButton} variant="outlined" color="secondary">debbierosas.com</Button>
              </div>
            </Zoom>
          </Grid>
          {/* Class Finder */}
          <Grid item xs={12} md={4} className={classes.threeOptionItemContainer}>
            <Zoom>
              <div className={classes.threeOptionsColumn}>
                <Typography className={classes.threeOptionsHeader} variant="h3" color="textSecondary">CLASSES</Typography>
                <Link to="/finder/class">
                  <img className={classes.icon} alt="An instructor leading one of Nia’s dance fitness classes" src={ClassImg} loading="lazy" />
                </Link>
                <Typography className={classes.sectionTextNewline} color="textSecondary">Find a Nia class near you or online and begin your journey of body and life transformation.</Typography>
                <Button href="/finder/class" className={classes.threeOptionButton} variant="outlined" color="secondary">Search</Button>
              </div>
            </Zoom>
          </Grid>
          {/* Nia On Demand */}
          <Grid item xs={12} md={4} className={classes.threeOptionItemContainer}>
            <Zoom>
              <div className={classes.threeOptionsColumn}>
                <Typography className={classes.threeOptionsHeader} variant="h3" color="textSecondary">NIA ON DEMAND</Typography>
                <a target="_blank" rel="noopener noreferrer" href="https://niaondemand.com">
                  <img className={classes.icon} alt="A television set playing one of Nia’s online dance workout classes" src={NiaTVImg} loading="lazy" />
                </a>
                <Typography className={classes.sectionText} color="textSecondary">Experience the magic of Nia through at-home dance workouts, podcasts, meditations and exclusive livestreams all at your fingertips.</Typography>
                <a target="_blank" rel="noopener noreferrer" className={classes.link} href="https://niaondemand.com">
                  <Button className={classes.threeOptionButton} variant="outlined" color="secondary">2 Weeks Free!</Button>
                </a>
              </div>
            </Zoom>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

ThreeOptionsSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ThreeOptionsSection);
